import React from "react";
import PropTypes from "prop-types";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { renderRichText } from "gatsby-source-contentful/rich-text";

const RichText = ({ data, className, listClassName, renderComponents, LinkRenderComponent }) => {
	// eslint-disable-next-line react/prop-types
	const Text = ({ children }) => <p>{children}</p>;

	const options = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
			[BLOCKS.UL_LIST]: (node, children) => <ul className={listClassName}>{children}</ul>,
			[BLOCKS.EMBEDDED_ENTRY]: node => (
				<p>{renderComponents ? renderComponents(node?.data?.target) : ""}</p>
			),
			[INLINES.EMBEDDED_ENTRY]: node =>
				renderComponents ? renderComponents(node?.data?.target) : "",
			[INLINES.HYPERLINK]: node => {
				const internal = /^\/(?!\/)/.test(node.data.uri);
				return LinkRenderComponent ? (
					<LinkRenderComponent
						to={node.data.uri}
						target={`${internal ? "_self" : "_blank"}`}
						rel={`${internal ? "" : "noopener noreferrer"}`}>
						{node.content[0].value}
					</LinkRenderComponent>
				) : (
					<a
						href={node.data.uri}
						target={`${node.data.uri.startsWith(internal) ? "_self" : "_blank"}`}
						rel={`${node.data.uri.startsWith(internal) ? "" : "noopener noreferrer"}`}>
						{node.content[0].value}
					</a>
				);
			},
		},
		renderText: text => text.split("\n").flatMap((_text, i) => [i > 0 && <br />, _text]),
	};
	return <div className={className}>{renderRichText(data, options)}</div>;
};

RichText.propTypes = {
	className: PropTypes.string,
	listClassName: PropTypes.string,
	data: PropTypes.object.isRequired,
	renderComponents: PropTypes.func,
	LinkRenderComponent: PropTypes.func,
};

RichText.defaultProps = {
	className: null,
	renderComponents: null,
	listClassName: null,
	LinkRenderComponent: null,
};
export default RichText;
export { RichText };
